<template>
  <div class="content">
    <!-- 基本信息 -->
    <div class="content-box content-service">
      <iframe :src="URL" frameborder="0" width="100%" height="100%"></iframe>
    </div>
    <div class="btn-group">
      <el-button @click="onCancel">{{$t('Common.com_cancel')}}</el-button>
      <!-- 租赁合同续租 -->
      <template v-if="backType==='continueRent'||(`${contractClass}`==='20'&&backType==='testToRent')">
          <el-button @click="preStep">{{$t('crm_contract_electronic.sybhtxx')}}</el-button>
      </template>
      <template v-else-if="`${contractClass}`==='31'&&backType==='testToRent'">
          <el-button @click="preStep">{{$t('crm_contract_electronic.sybtxljhc')}}</el-button>
      </template>
      <template v-else-if="`${contractClass}`==='31'&&backType==='continueOrder'">
          <el-button @click="preStep">{{$t('crm_contract_electronic.sybhtxx')}}</el-button>
      </template>
       <template v-else>
          <el-button @click="preStep">{{ $t('crm_contract_electronic.sybtxljhc')}}</el-button>
      </template>
      <el-button type="primary" @click="saveContract">{{$t('crm_contract_electronic.bao_cun_ti_jiao')}}</el-button>
      <el-button type="primary" @click="saveDraft">{{$t('crm_contract_electronic.bao_cun_cao_gao')}}</el-button>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  // components: { contractConfirmDialog },
  props: {
    backType: { type: String, default: '' },
    contractId: [String, Number],
    contractClass: [String, Number],
    operateFlag: [String, Number],
  },
  data() {
    return {
      URL: '',
      // // 确认签署
      // dialogVisible: false,
      // dialogModel: {},
      // dialogData: {},
    };
  },
  mounted() {
    this.getPreviewContract();
  },
  methods: {
    getPreviewContract: function () {
      this.$getJSON(`${apis.crmContractPreviewContract}/${this.contractId}`).then(
        (res) => {
          this.URL = res.data;
        }
      );
    },
    // 保存提交
    saveContract: function () {
      const parameter = {};
      parameter.operateFlag = this.operateFlag;
      parameter.bizId = this.contractId;
      parameter.bizClass = this.contractClass;
      parameter.isStartApprove = true;
      parameter.attachList = [];
      // 保存交互
      this.$postJSON(apis.crmContractSaveAttach, parameter).then((res) => {
        // 有返回值代表成功
        if (res.code === 0) {
          this.$message({
            message: this.$t('Common.com_save_success'),
            type: 'success',
          });
          this.$emit('successJump');
        }
      });

    },
    // 保存草稿
    saveDraft: function () {
      this.$message({
        message: this.$t('Common.com_save_success'),
        type: 'success',
      });
      this.$emit('successJump');
    },
    // 取消
    onCancel: function () {
      this.$emit('cancelJump');
    },
    sendContract: function () {
      this.$emit('success', 6);
    },
    preStep: function () {
      this.$emit('previous');
    },
  },
};
</script>

<style lang="scss">
@import "@/style/colors.scss";
.content-service {
  padding: 14px 24px 0;
}
</style>
